// extracted by mini-css-extract-plugin
export var csatScore = "_m1-5";
export var header = "_m1-1";
export var panelWrapper = "_m1-2";
export var postPreview = "_m1-3";
export var rightContent = "_m1-0";
export var wrappingText = "_m1-4";